module.exports = __webpack_public_path__ + "media/images/logos-customer-375f78c1.svg";